import {EmployeeBudget, ManagerStats} from "arteco-api-client-ts";
import {Alert, Table, TableBody, TableCell, TableHead, TableRow, Typography, useTheme} from "@mui/material";
import {Box} from "@mui/system";
import React from "react";

export interface EmpProductivityBudgetsProps {
	stats: ManagerStats;
}

export const EmpProductivityBudgets = ({stats}: EmpProductivityBudgetsProps) => {
	const theme = useTheme();

	const getDiff = (budget: EmployeeBudget): number => {
		const total = budget.totalBudgetHours || 0;
		const dedicated = budget.dedicatedHours || 0;
		if (total > 0) {
			return total - dedicated;
		} else {
			return 0;
		}
	}

	const balance = (stats: ManagerStats): number => {
		return (-(stats?.dedication?.unassignedHours || 0)
			- (stats?.dedication?.budgetHours || 0)
			+ (stats?.budgets?.reduce((acc, act) => acc + (act.totalBudgetHours || 0), 0) || 0)
		);
	}

	return (
		<>
			{stats && stats.budgets && stats.budgets.length > 0 && (
				<>

					<Typography mb={2} mt={4} variant="h6" color="textSecondary">
						PRESUPUESTOS
					</Typography>

					<Alert sx={{my: 2}} color={"success"}>
						Aquí podrás revisar los presupuestos activos que tienes asignados. Necesitarás el
						código de cliente y de presupuesto para indicarlo en las tareas de <b>redmine</b>.
						Recuerda que de no estar indicado en la tarea, se hará una búsqueda ascendente en la
						jerarquía.
					</Alert>

					<Table size="medium">
						<TableHead>
							<TableRow>
								<TableCell sx={{color: "white"}}>CLIENTE</TableCell>
								<TableCell sx={{color: "white"}}>TÍTULO</TableCell>
								<TableCell align={"center"} sx={{color: "white"}}>ANÁLISIS</TableCell>
								<TableCell align={"center"} sx={{color: "white"}}>ACEPTACIÓN</TableCell>
								<TableCell sx={{color: "white"}} align="right">PLANIFICADAS</TableCell>
								<TableCell sx={{color: "white"}} align="right">DEDICADAS</TableCell>
								<TableCell sx={{color: "white"}} align="right">DIFF</TableCell>
								<TableCell sx={{color: "white"}} align="right">% FACTURADO</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{stats?.budgets?.map((budget, idx) => (
								<TableRow key={idx}>
									<TableCell>{budget.customerId} - {budget.customerName}</TableCell>
									<TableCell>{budget.id} - {budget.title}</TableCell>
									<TableCell align="center"
											   sx={{color: !budget.analysis ? theme.palette.warning.main : undefined}}>
										{budget.analysis ? "Sí" : "Pendiente"}
									</TableCell>
									<TableCell align="center"
											   sx={{color: !budget.acceptation ? theme.palette.warning.main : undefined}}>
										{budget.acceptation ? "Sí" : "Pendiente"}
									</TableCell>
									<TableCell align="right">{budget.totalBudgetHours?.toFixed(1)}</TableCell>
									<TableCell align="right">{budget.dedicatedHours?.toFixed(1)}</TableCell>
									<TableCell align="right" sx={{color: getDiff(budget) >= 0 ? "green" : "red"}}>
										{getDiff(budget).toFixed(1)}
									</TableCell>
									<TableCell align="right">
										{budget.billedPct?.toFixed(1)}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
						<TableRow>
							<TableCell style={{fontWeight: "bold"}} colSpan={4} align={"right"}>PRESUPUESTOS</TableCell>
							<TableCell style={{fontWeight: "bold"}}
									   align={"right"}>{(stats?.budgets.reduce((acc, act) => acc + (act.totalBudgetHours || 0), 0) || 0).toFixed(1)}</TableCell>
							<TableCell style={{fontWeight: "bold"}}
									   align={"right"}>{(stats?.budgets.reduce((acc, act) => acc + (act.dedicatedHours || 0), 0) || 0).toFixed(1)}</TableCell>
							<TableCell style={{fontWeight: "bold"}}
									   align={"right"}>{(stats?.budgets.filter(b => (b.totalBudgetHours || 0) > 0).reduce((acc, act) => acc + ((act.totalBudgetHours || 0) - (act.dedicatedHours || 0)), 0) || 0).toFixed(1)}</TableCell>
							<TableCell></TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{fontWeight: "bold"}} colSpan={4} align={"right"}>SIN ASIGNAR</TableCell>
							<TableCell style={{fontWeight: "bold"}} align={"right"}></TableCell>
							<TableCell style={{fontWeight: "bold", color: "red"}} align={"right"}>
								{(stats?.dedication?.unassignedHours || 0).toFixed(1)}
							</TableCell>
							<TableCell style={{fontWeight: "bold"}} align={"right"}></TableCell>
							<TableCell style={{fontWeight: "bold"}} align={"right"}></TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{fontWeight: "bold"}} colSpan={4} align={"right"}>BALANCE</TableCell>
							<TableCell colSpan={2} align={"right"}>Planificadas menos dedicadas y no asignadas, excluyendo T&M.</TableCell>
							<TableCell style={{fontWeight: "bold", color: balance(stats) > 0 ? "green" : "red"}} align={"right"}>
								{balance(stats).toFixed(1)}
							</TableCell>
						</TableRow>
					</Table>

					<Box my={3} color={theme.palette.text.secondary}>
						Si la aceptación o el análisis está en
						<Box component={"span"} color={theme.palette.warning.main}>
							&nbsp;pendiente&nbsp;
						</Box>
						es porque no se tienen esos datos en la ficha del presupuesto,
						por favor contacta con el superior para completar esa información.
					</Box>

				</>
			)}
		</>

	);
}